import { render } from "./EmptySaveBtns.vue?vue&type=template&id=2d0b28b2&scoped=true"
import script from "./EmptySaveBtns.vue?vue&type=script&lang=js"
export * from "./EmptySaveBtns.vue?vue&type=script&lang=js"

import "./EmptySaveBtns.vue?vue&type=style&index=0&id=2d0b28b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0b28b2"]])

export default __exports__